module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }